import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import styled from 'styled-components';

const StyledSearchHeaderClearButton = styled(IconButtonComponent) `
  svg {
    margin-right: 2px;
    margin-top: 1px;
  }
`;
const StyledSearchHeaderForm = styled.form `
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: none;
  border-bottom: 1px solid ${props => props.theme.colors.darkGray}80;

  @media (pointer: fine) {
    &:hover {
      border-bottom: 1px solid ${props => props.theme.colors.darkGray};
    }
  }

  &:focus {
    border-bottom: 1px solid ${props => props.theme.colors.darkGray};
  }
`;
const StyledSearchHeaderField = styled.input `
  border: none;
  background: transparent;
  color: ${props => props.theme.colors.textColor};
  font-size: ${props => props.theme.typography.headings.h3.fontSize};
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  width: 100%;
  padding: 0 0 0.5rem;

  &::placeholder {
    color: ${props => props.theme.colors.mutedTextColor};
  }

  &:focus {
    outline: none;

    &::placeholder {
      color: transparent;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 0 0 0.75rem;
    font-size: ${props => props.theme.typography.headings.h2.fontSize};
  }
`;

export { StyledSearchHeaderClearButton, StyledSearchHeaderField, StyledSearchHeaderForm };
//# sourceMappingURL=SearchHeader.styles.mjs.map
